/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Collapse, Form, Input, Select, Checkbox, Button, message } from 'antd';
const { Panel } = Collapse;
const { Option } = Select;

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const grid = 8;

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? 'lightblue' : 'lightgrey',
  padding: grid,
  marginTop: 14,
  marginBottom: 14,
  marginRight:165
});

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  background: isDragging ? 'lightgrey' : 'grey',
  ...draggableStyle
});

const HeaderCustomization = (props) => {
  const [columnsProperties, setColumnsProperties] = useState(props.columnsProperties || []);
  const dragDisabled = useState(false);
  const [activeKey, setActiveKey] = useState([]);

  useEffect(() => {
    setColumnsProperties(props.columnsProperties || []);
  }, [props.columnsProperties]);

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const columnsPropertiess = reorder(
      columnsProperties,
      result.source.index,
      result.destination.index
    );
    setColumnsProperties(columnsPropertiess);
    props.columnSaveObject(columnsPropertiess);
  };

  const handleFieldChange = (value, index, colName) => {
    const updatedColumnsProperties = [...columnsProperties];
    updatedColumnsProperties[index] = { ...updatedColumnsProperties[index], [colName]: value };
    setColumnsProperties(updatedColumnsProperties);
  };
  

  const columnSave = () => {
    props.columnSaveObject(columnsProperties);
    message.success('Column saved');
    setActiveKey([]);
  };

  const deleteColumn = (e, index) => {
    const updatedColumnsProperties = columnsProperties.filter((_, i) => i !== index);
    props.columnSaveObject(updatedColumnsProperties);
    message.success('Column Deleted');
    setColumnsProperties(updatedColumnsProperties);
    setActiveKey([]);
  };  

  const callback = (key) => {
    if (key && key.length <= 1) {
      setActiveKey(key);
    } else if (key.length > 1) {
      key = key[key.length - 1];
      setActiveKey([key]);
    }
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 8 }
    }
  };

  return (
    <div style={{ margin: '20px' }}>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
              {...provided.droppableProps}
            >
              {columnsProperties.map((item, index) => (
                <Draggable
                  key={item.name}
                  draggableId={item.name}
                  index={index}
                  isDragDisabled={dragDisabled}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                    >
                      <Collapse bordered activeKey={activeKey} onChange={callback}>
                        <Panel header={item.name} key={index}>
                          <Form {...formItemLayout}>
                            <Form.Item label="Name :" style={{ paddingTop: '10px' }}>
                              <Input
                                autoFocus
                                defaultValue={item.name}
                                onChange={(e) =>
                                  handleFieldChange(e.target.value, index, 'name')
                                }
                              />
                            </Form.Item>
                            <Form.Item label="Key :" style={{ paddingTop: '10px' }}>
                              <Input
                                defaultValue={item.key}
                                onChange={(e) =>
                                  handleFieldChange(e.target.value, index, 'key')
                                }
                              />
                            </Form.Item>
                            <Form.Item label="Widget :" style={{ paddingTop: '10px' }}>
                              <Select
                                style={{ width: '250px' }}
                                defaultValue={item.widget}
                                onSelect={(value) =>
                                  handleFieldChange(value, index, 'widget')
                                }
                              >
                                <Option value="input">Input</Option>
                                <Option value="inputNumber">InputNumber</Option>
                                <Option value="select">Select</Option>
                                <Option value="timeRange">TimeRange</Option>
                                <Option value="text">None</Option>
                              </Select>
                            </Form.Item>
                            {item.widget === 'inputNumber' && (
                              <Form.Item label="Range :">
                                <Input
                                  placeholder={'Min'}
                                  style={{ width: '80px' }}
                                  defaultValue={item.min}
                                  onChange={(e) =>
                                    handleFieldChange(e.target.value, index, 'min')
                                  }
                                />
                                <Input
                                  placeholder={'Max'}
                                  style={{ width: '80px', marginLeft: '5px' }}
                                  defaultValue={item.max}
                                  onChange={(e) =>
                                    handleFieldChange(e.target.value, index, 'max')
                                  }
                                />
                              </Form.Item>
                            )}
                            <Form.Item label="Required :" style={{ paddingTop: '10px' }}>
                              <Checkbox
                                checked={item.required}
                                onChange={(e) =>
                                  handleFieldChange(e.target.checked, index, 'required')
                                }
                              />
                            </Form.Item>
                          </Form>
                          <div style={{ paddingTop: '20px' }}>
                          <Button
                            type="primary"
                            style={{ marginRight: '10px', color: 'black'}}
                            onClick={columnSave}
                          >
                            Save
                          </Button>
                          <Button
                            type="danger"
                            style={{ marginRight: '10px', color: 'black' }}
                            onClick={(e) => deleteColumn(e,index)}
                          >
                            Delete
                          </Button>
                          </div>
                        </Panel>
                      </Collapse>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

export default HeaderCustomization;
